export const FORMAT_TAGS = [
  "tutoriel",
  "decouverte",
  "bonnes-pratiques",
  "actualite",
  "cas-pratique",
] as const;

export type FormatTag = (typeof FORMAT_TAGS)[number];

export const FORMAT_TAG_META: Record<FormatTag, { labelKey: string }> = {
  "tutoriel":        { labelKey: "ressources.format.tutoriel" },
  "decouverte":      { labelKey: "ressources.format.decouverte" },
  "bonnes-pratiques":{ labelKey: "ressources.format.bonnesPratiques" },
  "actualite":       { labelKey: "ressources.format.actualite" },
  "cas-pratique":    { labelKey: "ressources.format.casPratique" },
};
